import { required } from "vuelidate/lib/validators";

const schemas = {
  achievement: {
    name: {
      required,
    },
    description: {
      required,
    },
    icon_background: {
      required,
    },
    icon_name: {
      required,
    },
  },
  shiftsCalendar: {
    dates: {
      required,
    },
    times: {
      required,
    },
  },
  user: {
    name: {
      required,
    },
    surname: {
      required,
    },
    patronymic: {
      required,
    },
  },
  passport: {
    date_of_birth: {
      required,
    },
    place_of_birth: {
      required,
    },
    registration_address: {
      required,
    },
    number: {
      required,
    },
    series: {
      required,
    },
    obtaining_passport_place: {
      required,
    },
    obtaining_passport_date: {
      required,
    },
  },
};

export default schemas;



// WEBPACK FOOTER //
// ./src/user/validation-schemas/index.js